import React from 'react';
import {px} from '@packages/systems/core/utils/WebflowCssSubset';
import {Atom, withSystem, withMeta, Plugins} from '@packages/systems/wfdl';
import {iconName, qualify, typeName} from '@packages/systems/wfdl-Qualified';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {TBoolean, TText, TTypeConstructor} from '@packages/systems/wfdl-ast';
import {
  USYS_INPUT_TYPES,
  USYS_DATA_ATTRS,
} from '@packages/systems/users/constants';

const UserSignUpTermsOfServiceCheckboxInput = Atom.createRender(
  ({attributes, classes, data, generateAttributes}) => {
    // @ts-expect-error - TS18046 - 'data' is of type 'unknown'
    const name = data.name || '';
    // @ts-expect-error - TS18046 - 'data' is of type 'unknown'
    const required = data.required || false;
    return (
      <input
        {...generateAttributes(attributes, classes)}
        name={name}
        type="checkbox"
        required={required}
        {...{[USYS_DATA_ATTRS.inputType]: USYS_INPUT_TYPES.acceptPrivacy}}
      />
    );
  }
);

const config = createIntegratedAtom({
  displayName: 'Terms of Service Checkbox',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Form'), iconName('Checkbox')),
  },
  showEmpty: false,
  constraints: {
    pinToParent: true,
  },
  style: {
    base: {
      main: {
        noPseudo: {
          marginRight: px(8),
          marginTop: px(4),
        },
      },
    },
  },

  render: UserSignUpTermsOfServiceCheckboxInput,
  fields: {
    name: withSystem(
      {label: 'Name', defaultValue: 'Terms of Service Checkbox'},
      TText
    ),
    required: withSystem({label: 'Required', defaultValue: false}, TBoolean),
    note: withMeta(
      {
        content:
          'Use this checkbox to link to your privacy policy and terms of service.',
      },
      withSystem(
        {defaultValue: false},
        TTypeConstructor(
          qualify(Plugins.name('Commerce'), typeName('DismissibleNote'))
        )
      )
    ),
  },
});

export default config;
